import React from 'react';
import { useSelector } from 'react-redux';
import { selectSwitchedUsername } from '../selectors';
import { useUserSwitchActions } from '../hooks';
import { Box } from '@mui/material';
import { Trans } from 'react-i18next';
import { useTranslation } from 'utils/translation';
import Card from '../../../components/v2/Card/Card';
import Typography from 'components/v2/Typography/Typography';
import { Button } from '../../../components/v2/Button/Button';
import Icon from '../../../components/v2/Icon/Icon';
import { Stack } from '../../../components/v2/Stack/Stack';

const SwitchedUserNotification = () => {
  const { t } = useTranslation();
  const switchedUser = useSelector(selectSwitchedUsername);
  const { resetUser } = useUserSwitchActions();

  if (switchedUser) {
    return (
      <Box
        sx={{
          position: 'fixed',
          left: 4,
          bottom: 2,
          zIndex: 10000,
        }}
      >
        <Card shadow>
          <Card.Content>
            <Stack direction="column" gap={2}>
              <Typography variant="caption" component="span">
                <Trans i18nKey="acting_as_user">
                  {/* @ts-ignore */}
                  You are acting as user <strong>{{ switchedUser }}</strong>
                </Trans>
              </Typography>
              <Button
                size="xs"
                onClick={() => resetUser()}
                startIcon={<Icon name="fa-regular fa-chevron-left" />}
              >
                {t('leave_switched_user_account')}
              </Button>
            </Stack>
          </Card.Content>
        </Card>
      </Box>
    );
  }

  return null;
};

export default SwitchedUserNotification;
